/* eslint-disable css-modules/no-undef-class */
import React from 'react';
import cx from 'classnames';
import validator from 'validator';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import InputMask from 'react-input-mask';
import { bindActionCreators } from 'redux';
import { injectIntl, FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

// import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';
// import { getGoogleCaptchaTokenV2 } from 'shared/helpers/google';

import {
  userAuthorize,
  loginWithFacebookToken,
  beforeRegistration as setBeforeRegistration,
  userCheckCode,
  registration,
  userRecovery,
  logistics,
  renderRecaptchaV2,
} from 'shared/actions/user';
import URL from 'shared/constants/url';
import regexp from 'shared/constants/regexp';
import Link from 'shared/components/Link/Link';
import withOrders from 'shared/hocs/withOrders';
// import { FB_APP_ID } from 'shared/constants/fb';
import { EVENTS } from 'shared/constants/gtmEvents';
import { setDataLayer } from 'shared/actions/globals';
import logoUrl from 'shared/assets/images/logo.png';
import Loader from 'shared/components/Loader/Loader';

import Row from 'shared/components/AntdComponents/Grid/Row/Row';
import Icon from 'shared/components/AntdComponents/Icon/Icon';
import Form from 'shared/components/AntdComponents/Form/Form';
import Input from 'shared/components/AntdComponents/Input/Input';

import { enqueueNotification } from 'shared/actions/notifications';
import { notEmptyField, phoneNormalize, transformTrim } from 'shared/modules';

import s from './LoginUsForm.css';

const FormItem = Form.Item;
const isMobile = __APP__ === 'mobile';
class loginUsForm extends React.Component {
  static propTypes = {
    form: PropTypes.shape({
      getFieldsValue: PropTypes.func,
      validateFieldsAndScroll: PropTypes.func,
      resetFields: PropTypes.func,
    }),
    intl: PropTypes.shape({ locale: PropTypes.string }),
    action: PropTypes.shape({
      userAuthorize: PropTypes.func,
      logistics: PropTypes.func,
      loginWithFacebookToken: PropTypes.func,
    }),
    modal: PropTypes.bool,
    loading: PropTypes.bool,
    notRedirect: PropTypes.bool,
    dispatch: PropTypes.func.isRequired,
    setDataLayer: PropTypes.func.isRequired,
    enqueueNotification: PropTypes.func.isRequired,
    setBeforeRegistration: PropTypes.func.isRequired,
    user: PropTypes.shape({ token: PropTypes.string }),
  };
  static defaultProps = {
    loading: false,
    notRedirect: false,
    handleChange: () => {},
    modal: false,
    user: { user: {}, beforeRegistration: {} },
    action: {},
    form: {},
    intl: {},
  };
  state = {
    initialStart: false,
  };
  componentWillUnmount() {
    const {
      form: { resetFields },
      dispatch,
      setBeforeRegistration: clearBeforeRegistration,
    } = this.props;
    resetFields();
    dispatch(clearBeforeRegistration());
  }
  handleAddNextButtonCommon = () => {
    this.props.setDataLayer(EVENTS.AddNextButtonCommon);
  };
  handleChange(key, data) {
    const {
      action,
      form: { setFields, getFieldValue, resetFields },
      modal,
      notRedirect,
      intl,
      user: { user },
      dispatch,
      setBeforeRegistration: clearBeforeRegistration,
    } = this.props;

    const fun = {
      logoSet: () => {
        this.setState({ initialStart: true }, () => {
          this.props.form.validateFieldsAndScroll(null, { force: true }, (errors, values) => {
            if (errors) {
              console.error(errors);
              return;
            }
            action.userAuthorize(
              {
                thing: transformTrim(values.emailAndPhone),
                password: transformTrim(values.password),
              },
              {
                setFields,
                modal: modal || notRedirect,
                enqueueNotification: this.props.enqueueNotification,
                intl,
              },
            );
          });
        });
      },
      checkCode: dat => {
        this.setState({ initialStart: true }, () => {
          this.props.form.validateFieldsAndScroll(null, { force: true }, (errors, values) => {
            const datValues = String(transformTrim(getFieldValue('emailAndPhone')));
            if (errors && !dat) {
              console.error(errors);
              return;
            }
            if (dat && !(regexp.phone.test(datValues) || validator.isEmail(datValues))) {
              console.error(errors);
              return;
            }
            action.userCheckCode(
              {
                callback: () => {
                  this.setState({ initialStart: false });
                },
                registration: Boolean(dat),
                thing: transformTrim(values.emailAndPhone),
              },
              {
                setFields,
                modal: modal || notRedirect,
                enqueueNotification: this.props.enqueueNotification,
                intl,
              },
            );
          });
        });
      },
      facebookLogoSet: dat => {
        this.props.action.loginWithFacebookToken(dat.accessToken, {
          setFields,
          modal: modal || notRedirect,
          enqueueNotification: this.props.enqueueNotification,
          intl,
        });
      },
      formSet: () => {
        this.setState({ initialStart: true, trueSet: true }, () => {
          this.props.form.validateFieldsAndScroll(null, { force: true }, (errors, values) => {
            if (errors) {
              console.error(errors);
              return;
            }
            action.registration(transformTrim(values), {
              setFields,
              modal: modal || notRedirect,
              enqueueNotification: this.props.enqueueNotification,
              intl,
            });
          });
        });
      },
      passwordSet: () => {
        this.setState({ initialpasswordStart: true }, () => {
          this.props.form.validateFieldsAndScroll(null, { force: true }, (errors, values) => {
            if (errors) {
              console.error(errors);
              return;
            }
            action.userAuthorize(
              {
                thing: transformTrim(values.phone),
                password: transformTrim(values.password),
              },
              {
                setFields,
                modal: modal || notRedirect,
                enqueueNotification: this.props.enqueueNotification,
                intl,
                registrationForm: true,
              },
            );
          });
        });
      },
      justOncepassword: () => {
        const phone = transformTrim(getFieldValue('phone'));
        if (!regexp.phone.test(String(phone))) {
          setFields({
            phone: {
              value: phone || '',
              errors: [new Error(intl.formatMessage({ id: 'Введите номер телефона' }))],
            },
          });
          return;
        }
        this.setState({ justOncepasswordStart: true }, () => {
          action.userRecovery(
            {
              thing: phone,
            },
            {
              setFields,
              modal: modal || notRedirect,
              enqueueNotification: this.props.enqueueNotification,
              intl,
              registrationForm: true,
            },
          );
        });
      },
      trueSet: ({ value }) => {
        const email = String(transformTrim(getFieldValue('email')));
        const name = String(transformTrim(getFieldValue('name')));
        const phone = String(transformTrim(getFieldValue('phone')));
        if (
          value &&
          validator.isEmail(email) &&
          regexp.name.test(name) &&
          regexp.phone.test(phone) &&
          `${phone}${name}${email}` !== this.state.emailNamePhone
        ) {
          this.setState({ emailNamePhone: `${phone}${name}${email}` }, () => {});
        }
      },
      recoverypassword: () => {
        const dat = String(transformTrim(getFieldValue('emailAndPhone')));
        if (!regexp.phone.test(dat) && !validator.isEmail(dat)) {
          setFields({
            emailAndPhone: {
              value: (dat !== 'undefined' && dat) || '',
              errors: [
                new Error(intl.formatMessage({ id: 'Некорректный формат телефона или почты' })),
              ],
            },
          });
          return;
        }
        action.userRecovery(
          {
            userCheckCode,
            thing: dat,
          },
          {
            setFields,
            modal: modal || notRedirect,
            enqueueNotification: this.props.enqueueNotification,
            intl,
          },
        );
      },
      clear: () => {
        resetFields();
        this.setState({ initialStart: false }, () => {
          dispatch(clearBeforeRegistration());
        });
      },
      logistics: dat => {
        const logicData = {
          event: 'view',
          object_id: 0,
          object_type: 'advert',
          event_id: dat,
          user_id: user.id,
          button: 'password recovery',
        };
        const datValues = String(transformTrim(getFieldValue('emailAndPhone')));

        if (regexp.phone.test(datValues)) {
          logicData.phone = datValues;
        }
        if (validator.isEmail(datValues)) {
          logicData.email = datValues;
        }
        action.logistics(logicData);
      },
    };

    if (fun[key]) {
      fun[key](data);
    } else {
      console.error(key);
    }
  }

  renderCaptcha() {
    const { recaptchaReady } = this.props.user.beforeRegistration;
    if (!recaptchaReady) {
      setTimeout(() => {
        this.props.action.renderRecaptchaV2('captchav2');
      }, 100);
    }
    return <div id="captchav2" className={s.captcha} />;
  }

  render() {
    const {
      form,
      intl,
      loading,
      modal,
      user: { beforeRegistration = {}, user = {} },
    } = this.props;
    const { getFieldDecorator } = form;
    // console.log('>> ', getFieldDecorator, form);
    const { checkCodeUser: checkCode, existsEmail, existsPhone, gr, gtokenv2 } = beforeRegistration;
    const userRes = Boolean(beforeRegistration.id || user.id || this.state.justOncepasswordStart);

    const errs = form.getFieldsError();
    if (!loading && gtokenv2 && (errs.email || errs.phone)) {
      gr.reset();
    }

    if (modal) {
      if (isMobile) {
        if (existsEmail || existsPhone) {
          return (
            <div className={s.card}>
              <div className={s.root}>
                {existsEmail ? (
                  <FormItem>
                    {getFieldDecorator('email', {
                      initialValue: beforeRegistration.email || existsEmail || '',
                      rules: [
                        {
                          transform: transformTrim,
                          validator: (rule, value, cb) => {
                            if (!this.state.initialStart || (value && validator.isEmail(value))) {
                              cb();
                              this.handleChange('trueSet', { value, userRes });
                            } else {
                              cb(
                                intl.formatMessage({
                                  id: notEmptyField(value, 'Некорректная электронная почта'),
                                }),
                              );
                            }
                          },
                        },
                      ],
                    })(
                      <Input
                        type="text"
                        name="username"
                        disabled={userRes}
                        className={s.inputMob}
                        onPressEnter={() => this.handleChange(userRes ? 'passwordSet' : 'formSet')}
                        placeholder={intl.formatMessage({
                          id: 'Электронная почта',
                        })}
                      />,
                    )}
                  </FormItem>
                ) : (
                  ''
                )}

                <FormItem>
                  {getFieldDecorator('phone', {
                    initialValue:
                      (beforeRegistration.phones &&
                        beforeRegistration.phones[0] &&
                        beforeRegistration.phones[0].number &&
                        phoneNormalize(beforeRegistration.phones[0].number)) ||
                      existsPhone ||
                      '',
                    rules: [
                      {
                        transform: transformTrim,
                        validator: (rule, value, cb) => {
                          if (
                            !this.state.initialStart ||
                            (value && regexp.phoneOperators.test(value))
                          ) {
                            cb();
                            this.handleChange('trueSet', { value, userRes });
                          } else {
                            cb(
                              intl.formatMessage({
                                id: notEmptyField(value, 'Некорректный номер мобильного телефона'),
                              }),
                            );
                          }
                        },
                      },
                    ],
                  })(
                    <InputMask
                      disabled={userRes}
                      onKeyPress={event => {
                        if (event.key === 'Enter') {
                          this.handleChange(userRes ? 'passwordSet' : 'formSet');
                        }
                      }}
                      className={cx(s.inputMob, { 'ant-input-disabled': userRes })}
                      mask="\+38(099)999-99-99"
                      maskChar=" "
                      type="text"
                      placeholder={intl.formatMessage({
                        id: 'Мобильный телефон',
                      })}
                    />,
                  )}
                </FormItem>
                {!existsEmail ? (
                  <FormItem>
                    {getFieldDecorator('email', {
                      initialValue: beforeRegistration.email,
                      rules: [
                        {
                          transform: transformTrim,
                          validator: (rule, value, cb) => {
                            if (!this.state.initialStart || (value && validator.isEmail(value))) {
                              cb();
                              this.handleChange('trueSet', { value, userRes });
                            } else {
                              cb(
                                intl.formatMessage({
                                  id: notEmptyField(value, 'Некорректная электронная почта'),
                                }),
                              );
                            }
                          },
                        },
                      ],
                    })(
                      <Input
                        type="text"
                        name="username"
                        disabled={userRes}
                        className={s.inputMob}
                        onPressEnter={() => this.handleChange(userRes ? 'passwordSet' : 'formSet')}
                        placeholder={intl.formatMessage({
                          id: 'Электронная почта',
                        })}
                      />,
                    )}
                  </FormItem>
                ) : (
                  ''
                )}
                <FormItem>
                  {getFieldDecorator('name', {
                    initialValue: beforeRegistration.name,
                    rules: [
                      {
                        transform: transformTrim,
                        validator: (rule, value, cb) => {
                          if (!this.state.initialStart || (value && regexp.name.test(value))) {
                            cb();
                            this.handleChange('trueSet', { value, userRes });
                          } else {
                            cb(
                              intl.formatMessage({ id: notEmptyField(value, 'Некорректная имя') }),
                            );
                          }
                        },
                      },
                    ],
                  })(
                    <Input
                      type="text"
                      name="username"
                      disabled={userRes}
                      className={s.inputMob}
                      onPressEnter={() => this.handleChange(userRes ? 'passwordSet' : 'formSet')}
                      placeholder={intl.formatMessage({
                        id: `Имя${!isMobile ? ' (видят покупатели)' : ''}`,
                      })}
                    />,
                  )}
                </FormItem>
                {userRes
                  ? [
                      <FormItem key="one">
                        {getFieldDecorator('password', {
                          rules: [
                            {
                              transform: transformTrim,
                              validator: (rule, value, cb) => {
                                if (
                                  !this.state.initialpasswordStart ||
                                  (value && regexp.password.test(value))
                                ) {
                                  cb();
                                } else {
                                  cb(
                                    intl.formatMessage({
                                      id: notEmptyField(value, 'Введите пароль'),
                                    }),
                                  );
                                }
                              },
                            },
                          ],
                        })(
                          <Input
                            name="password"
                            type="password"
                            onPressEnter={() =>
                              this.handleChange(userRes ? 'passwordSet' : 'formSet')
                            }
                            className={s.inputMob}
                            placeholder={intl.formatMessage({
                              id: 'Введите полученный пароль',
                            })}
                          />,
                        )}
                      </FormItem>,
                    ]
                  : ''}
                <div className={cx(s.centerBlock)}>
                  <div>
                    <Link className={cx(s.urlGl)} onClick={() => this.handleChange('clear')}>
                      <FormattedMessage id="Я уже зарегистрирован (а)" />
                    </Link>
                  </div>
                  <div />
                  {userRes ? (
                    <div>
                      <Link
                        className={cx(s.urlGl)}
                        onClick={() => this.handleChange('justOncepassword')}
                      >
                        <FormattedMessage id="Направить пароль еще раз" />
                      </Link>
                    </div>
                  ) : (
                    ''
                  )}
                </div>
                {loading.start ? (
                  <Row>
                    <Loader isLoading />
                  </Row>
                ) : (
                  <Row>
                    <button
                      className={s.buttonFormGl}
                      onClick={() => {
                        this.handleChange(userRes ? 'passwordSet' : 'formSet');
                        this.handleAddNextButtonCommon();
                      }}
                    >
                      <p>
                        <FormattedMessage id="Далее" />
                      </p>
                    </button>
                  </Row>
                )}
              </div>
            </div>
          );
        }
        return (
          <div className={s.card}>
            <div className={s.root}>
              <FormItem>
                {getFieldDecorator('emailAndPhone', {
                  initialValue: beforeRegistration.email,
                  rules: [
                    {
                      transform: transformTrim,
                      validator: (rule, value, cb) => {
                        if (
                          !this.state.initialStart ||
                          (value &&
                            (validator.isEmail(value) || (value && regexp.phone.test(value))))
                        ) {
                          cb();
                        } else {
                          cb(
                            intl.formatMessage({
                              id: notEmptyField(value, 'Некорректный формат телефона или почты'),
                            }),
                          );
                        }
                      },
                    },
                  ],
                })(
                  <Input
                    name="username"
                    type="text"
                    disabled={checkCode}
                    className={s.inputMobLogin}
                    suffix={
                      checkCode ? (
                        <Icon
                          type="close"
                          onClick={() => this.handleChange('clear')}
                          style={{ cursor: 'pointer' }}
                        />
                      ) : (
                        <p />
                      )
                    }
                    onPressEnter={() => this.handleChange(checkCode ? 'logoSet' : 'checkCode')}
                    placeholder={intl.formatMessage({
                      id: 'Почта или телефон',
                    })}
                  />,
                )}
              </FormItem>

              {checkCode ? (
                <FormItem>
                  {getFieldDecorator('password', {
                    rules: [
                      {
                        transform: transformTrim,
                        validator: (rule, value, cb) => {
                          if (!this.state.initialStart || (value && regexp.password.test(value))) {
                            cb();
                          } else {
                            cb(
                              intl.formatMessage({
                                id: notEmptyField(value, 'Введите пароль'),
                              }),
                            );
                          }
                        },
                      },
                    ],
                  })(
                    <Input
                      type="password"
                      name="password"
                      className={s.inputMob}
                      onPressEnter={() => this.handleChange(checkCode ? 'logoSet' : 'checkCode')}
                      placeholder={intl.formatMessage({
                        id: 'Введите пароль',
                      })}
                    />,
                  )}
                </FormItem>
              ) : (
                ''
              )}
              <div className={cx(s.centerBlock)}>
                <div>
                  {checkCode ? (
                    <Link className={s.urlGl} onClick={() => this.handleChange('checkCode', true)}>
                      <FormattedMessage id="Зарегистрироваться" />
                    </Link>
                  ) : (
                    ''
                  )}
                </div>
                <div />

                <div>
                  {checkCode ? (
                    <Link
                      className={cx(s.urlGl)}
                      onClick={() => {
                        this.handleChange('logistics', 'KLODESBggakE');
                        this.handleChange('recoverypassword');
                      }}
                    >
                      <FormattedMessage id="Забыли пароль ?" />
                    </Link>
                  ) : (
                    ''
                  )}
                </div>
              </div>
              <Row>
                <button
                  onClick={() => {
                    this.handleChange(checkCode ? 'logoSet' : 'checkCode');
                    this.handleAddNextButtonCommon();
                  }}
                  className={s.buttonFormGl}
                >
                  <p>
                    <FormattedMessage id="Далее" />
                  </p>
                </button>
              </Row>
            </div>
          </div>
        );
      }
      if (existsEmail || existsPhone) {
        return (
          <div className={s.card}>
            <div className={s.root}>
              {existsEmail ? (
                <div className={s.flexRow}>
                  <div className={cx(s.left, { [s.required]: isMobile })}>
                    <FormattedMessage id="Почта" />
                  </div>
                  <div className={s.right}>
                    <FormItem>
                      {getFieldDecorator('email', {
                        initialValue: beforeRegistration.email || existsEmail || '',
                        rules: [
                          {
                            transform: transformTrim,
                            validator: (rule, value, cb) => {
                              if (!this.state.initialStart || (value && validator.isEmail(value))) {
                                cb();
                                this.handleChange('trueSet', { value, userRes });
                              } else {
                                cb(
                                  intl.formatMessage({
                                    id: notEmptyField(value, 'Некорректная электронная почта'),
                                  }),
                                );
                              }
                            },
                          },
                        ],
                      })(
                        <Input
                          type="text"
                          name="username"
                          disabled={userRes}
                          className={s.input}
                          onPressEnter={() =>
                            this.handleChange(userRes ? 'passwordSet' : 'formSet')
                          }
                          placeholder={intl.formatMessage({
                            id: 'Электронная почта',
                          })}
                        />,
                      )}
                    </FormItem>
                  </div>
                </div>
              ) : (
                ''
              )}
              <div className={s.flexRow}>
                <div className={cx(s.left, { [s.required]: isMobile })}>
                  <FormattedMessage id="Телефон" />
                </div>
                <div className={s.right}>
                  <div>
                    <FormItem>
                      {getFieldDecorator('phone', {
                        initialValue:
                          (beforeRegistration.phones &&
                            beforeRegistration.phones[0] &&
                            beforeRegistration.phones[0].number &&
                            phoneNormalize(beforeRegistration.phones[0].number)) ||
                          existsPhone ||
                          '',
                        rules: [
                          {
                            transform: transformTrim,
                            validator: (rule, value, cb) => {
                              if (
                                !this.state.initialStart ||
                                (value && regexp.phoneOperators.test(value))
                              ) {
                                cb();
                                this.handleChange('trueSet', { value, userRes });
                              } else {
                                cb(
                                  intl.formatMessage({
                                    id: notEmptyField(
                                      value,
                                      'Некорректный номер мобильного телефона',
                                    ),
                                  }),
                                );
                              }
                            },
                          },
                        ],
                      })(
                        <InputMask
                          disabled={userRes}
                          onKeyPress={event => {
                            if (event.key === 'Enter') {
                              this.handleChange(userRes ? 'passwordSet' : 'formSet');
                            }
                          }}
                          className={cx(s.input, { 'ant-input-disabled': userRes })}
                          mask="\+38(099)999-99-99"
                          maskChar=" "
                          type="text"
                          placeholder={intl.formatMessage({
                            id: 'Мобильный телефон',
                          })}
                        />,
                      )}
                    </FormItem>
                  </div>
                </div>
              </div>
              {!existsEmail ? (
                <div className={s.flexRow}>
                  <div className={cx(s.left, { [s.required]: isMobile })}>
                    <FormattedMessage id="Почта" />
                  </div>
                  <div className={s.right}>
                    <FormItem>
                      {getFieldDecorator('email', {
                        initialValue: beforeRegistration.email || '',
                        rules: [
                          {
                            transform: transformTrim,
                            validator: (rule, value, cb) => {
                              if (!this.state.initialStart || (value && validator.isEmail(value))) {
                                cb();
                                this.handleChange('trueSet', { value, userRes });
                              } else {
                                cb(
                                  intl.formatMessage({
                                    id: notEmptyField(value, 'Некорректная электронная почта'),
                                  }),
                                );
                              }
                            },
                          },
                        ],
                      })(
                        <Input
                          type="text"
                          name="username"
                          disabled={userRes}
                          className={s.input}
                          onPressEnter={() =>
                            this.handleChange(userRes ? 'passwordSet' : 'formSet')
                          }
                          placeholder={intl.formatMessage({
                            id: 'Электронная почта',
                          })}
                        />,
                      )}
                    </FormItem>
                  </div>
                </div>
              ) : (
                ''
              )}
              <div className={s.flexRow}>
                <div className={cx(s.left, { [s.required]: isMobile })}>
                  <FormattedMessage id="Контактное лицо" />
                </div>
                <div className={s.right}>
                  <FormItem>
                    {getFieldDecorator('name', {
                      initialValue: beforeRegistration.name,
                      rules: [
                        {
                          transform: transformTrim,
                          validator: (rule, value, cb) => {
                            if (!this.state.initialStart || (value && regexp.name.test(value))) {
                              cb();
                              this.handleChange('trueSet', { value, userRes });
                            } else {
                              cb(
                                intl.formatMessage({
                                  id: notEmptyField(value, 'Некорректная имя'),
                                }),
                              );
                            }
                          },
                        },
                      ],
                    })(
                      <Input
                        type="text"
                        name="username"
                        disabled={userRes}
                        className={s.input}
                        onPressEnter={() => this.handleChange(userRes ? 'passwordSet' : 'formSet')}
                        placeholder={intl.formatMessage({
                          id: `Имя${!isMobile ? ' (видят покупатели)' : ''}`,
                        })}
                      />,
                    )}
                  </FormItem>
                </div>
              </div>
              {userRes
                ? [
                    <div className={s.flexRow} key="0">
                      <div className={cx(s.left, { [s.required]: isMobile })}>
                        <FormattedMessage id="Пароль" />
                      </div>
                      <div className={s.right}>
                        <FormItem>
                          {getFieldDecorator('password', {
                            rules: [
                              {
                                transform: transformTrim,
                                validator: (rule, value, cb) => {
                                  if (
                                    !this.state.initialpasswordStart ||
                                    (value && regexp.password.test(value))
                                  ) {
                                    cb();
                                  } else {
                                    cb(
                                      intl.formatMessage({
                                        id: notEmptyField(value, 'Введите пароль'),
                                      }),
                                    );
                                  }
                                },
                              },
                            ],
                          })(
                            <Input
                              name="username"
                              type="password"
                              onPressEnter={() =>
                                this.handleChange(userRes ? 'passwordSet' : 'formSet')
                              }
                              className={s.input}
                              placeholder={intl.formatMessage({
                                id: 'Введите полученный пароль',
                              })}
                            />,
                          )}
                        </FormItem>
                      </div>
                    </div>,
                  ]
                : ''}
              <Row className={cx(s.flexRow)}>
                <div className={cx(s.left)} />
                <div className={cx(s.right, s.centerBlock)}>
                  <div>
                    <Link className={cx(s.urlGl)} onClick={() => this.handleChange('clear')}>
                      <FormattedMessage id="Я уже зарегистрирован (а)" />
                    </Link>
                  </div>
                  {userRes ? (
                    <div>
                      <Link
                        className={cx(s.urlGl)}
                        onClick={() => this.handleChange('justOncepassword')}
                      >
                        <FormattedMessage id="Направить пароль еще раз" />
                      </Link>
                    </div>
                  ) : (
                    ''
                  )}
                </div>
              </Row>
              {this.renderCaptcha()}
              {loading.start ? (
                <Row>
                  <Loader isLoading />
                </Row>
              ) : (
                <Row>
                  <button
                    disabled={!gtokenv2}
                    className={s.buttonFormGl}
                    onClick={() => {
                      this.handleChange(userRes ? 'passwordSet' : 'formSet');
                      this.handleAddNextButtonCommon();
                    }}
                  >
                    <p>
                      <FormattedMessage id="Далее" />
                    </p>
                  </button>
                </Row>
              )}
            </div>
          </div>
        );
      }
      return (
        <div className={s.card}>
          <div className={s.root}>
            <div className={s.flexRow}>
              <div className={cx(s.left, { [s.required]: isMobile })}>
                <FormattedMessage id="Почта или телефон" />
              </div>
              <div className={s.right}>
                <FormItem>
                  {getFieldDecorator('emailAndPhone', {
                    initialValue: beforeRegistration.mailVerify || beforeRegistration.email || '',
                    rules: [
                      {
                        transform: transformTrim,
                        validator: (rule, value, cb) => {
                          if (
                            !this.state.initialStart ||
                            (value &&
                              (validator.isEmail(value) || (value && regexp.phone.test(value))))
                          ) {
                            cb();
                          } else {
                            cb(
                              intl.formatMessage({
                                id: notEmptyField(value, 'Некорректный формат телефона или почты'),
                              }),
                            );
                          }
                        },
                      },
                    ],
                  })(
                    <Input
                      type="text"
                      name="username"
                      disabled={checkCode}
                      className={s.inputLogin}
                      suffix={
                        checkCode ? (
                          <Icon
                            type="close"
                            onClick={() => this.handleChange('clear')}
                            style={{ cursor: 'pointer' }}
                          />
                        ) : (
                          <p />
                        )
                      }
                      onPressEnter={() => this.handleChange(checkCode ? 'logoSet' : 'checkCode')}
                      placeholder={intl.formatMessage({
                        id: isMobile
                          ? 'Почта или телефон'
                          : 'Введите электронную почту или телефон',
                      })}
                    />,
                  )}
                </FormItem>
              </div>
            </div>
            {checkCode ? (
              <React.Fragment>
                <div className={s.flexRow}>
                  <div className={cx(s.left, { [s.required]: isMobile })}>
                    <FormattedMessage id="Пароль" />
                  </div>
                  <div className={s.right}>
                    <FormItem>
                      {getFieldDecorator('password', {
                        rules: [
                          {
                            transform: transformTrim,
                            validator: (rule, value, cb) => {
                              if (
                                !this.state.initialStart ||
                                (value && regexp.password.test(value))
                              ) {
                                cb();
                              } else {
                                cb(
                                  intl.formatMessage({
                                    id: notEmptyField(value, 'Введите пароль'),
                                  }),
                                );
                              }
                            },
                          },
                        ],
                      })(
                        <Input
                          type="password"
                          name="password"
                          className={s.input}
                          onPressEnter={() =>
                            this.handleChange(checkCode ? 'logoSet' : 'checkCode')
                          }
                          placeholder={intl.formatMessage({
                            id: 'Введите пароль',
                          })}
                        />,
                      )}
                    </FormItem>
                  </div>
                </div>
              </React.Fragment>
            ) : (
              ''
            )}
            <div className={s.flexRow}>
              <div className={cx(s.left)} />

              <div className={cx(s.right, s.centerBlock)}>
                <div>
                  {checkCode ? (
                    <Link className={s.urlGl} onClick={() => this.handleChange('checkCode', true)}>
                      <FormattedMessage id="Зарегистрироваться" />
                    </Link>
                  ) : (
                    ''
                  )}
                </div>
                <div />
                <div>
                  {checkCode ? (
                    <Link
                      className={cx(s.urlGl)}
                      onClick={() => {
                        this.handleChange('logistics', 'cx2pR6ShRZHzIv9');
                        this.handleChange('recoverypassword');
                      }}
                    >
                      <FormattedMessage id="Забыли пароль ?" />
                    </Link>
                  ) : (
                    ''
                  )}
                </div>
              </div>
            </div>

            <Row>
              <button
                className={s.buttonFormGl}
                onClick={() => {
                  this.handleChange(checkCode ? 'logoSet' : 'checkCode');
                  this.handleAddNextButtonCommon();
                }}
              >
                <p>
                  <FormattedMessage id="Далее" />
                </p>
              </button>
            </Row>
          </div>
        </div>
      );
    }
    if (existsEmail || existsPhone) {
      return (
        <div>
          <Row>
            <Link to="/">
              <div className={s.sbsGL}>
                <img src={logoUrl} width={224} alt="avtobazar.ua" />
              </div>
            </Link>
          </Row>
          <Row>
            <div className={s.titleNellGl}>
              <FormattedMessage id="Регистрация" />
            </div>
          </Row>
          {existsEmail ? (
            <Row>
              <FormItem>
                {getFieldDecorator('email', {
                  initialValue: beforeRegistration.email || existsEmail || '',
                  rules: [
                    {
                      transform: transformTrim,
                      validator: (rule, value, cb) => {
                        if (!this.state.initialStart || (value && validator.isEmail(value))) {
                          cb();
                          this.handleChange('trueSet', { value, userRes });
                        } else {
                          cb(
                            intl.formatMessage({
                              id: notEmptyField(value, 'Некорректная электронная почта'),
                            }),
                          );
                        }
                      },
                    },
                  ],
                })(
                  <Input
                    type="text"
                    name="username"
                    disabled={userRes}
                    className={cx({
                      [s.inputFormMobil]: isMobile,
                      [s.inputForm]: !isMobile,
                    })}
                    onPressEnter={() => this.handleChange(userRes ? 'passwordSet' : 'formSet')}
                    placeholder={intl.formatMessage({
                      id: 'Электронная почта',
                    })}
                  />,
                )}
              </FormItem>
            </Row>
          ) : (
            ''
          )}
          <Row>
            <FormItem>
              {getFieldDecorator('phone', {
                initialValue:
                  (beforeRegistration.phones &&
                    beforeRegistration.phones[0] &&
                    beforeRegistration.phones[0].number &&
                    phoneNormalize(beforeRegistration.phones[0].number)) ||
                  existsPhone ||
                  '',
                rules: [
                  {
                    transform: transformTrim,
                    validator: (rule, value, cb) => {
                      if (
                        !this.state.initialStart ||
                        (value && regexp.phoneOperators.test(value))
                      ) {
                        cb();
                        this.handleChange('trueSet', { value, userRes });
                      } else {
                        cb(
                          intl.formatMessage({
                            id: notEmptyField(value, 'Некорректный номер мобильного телефона'),
                          }),
                        );
                      }
                    },
                  },
                ],
              })(
                <InputMask
                  disabled={userRes}
                  onKeyPress={event => {
                    if (event.key === 'Enter') {
                      this.handleChange(userRes ? 'passwordSet' : 'formSet');
                    }
                  }}
                  className={cx({
                    [s.inputFormMobil]: isMobile,
                    [s.inputForm]: !isMobile,
                    'ant-input-disabled': userRes,
                  })}
                  mask="\+38(099)999-99-99"
                  maskChar=" "
                  type="text"
                  placeholder={intl.formatMessage({
                    id: 'Мобильный телефон',
                  })}
                />,
              )}
            </FormItem>
          </Row>
          {!existsEmail ? (
            <Row>
              <FormItem>
                {getFieldDecorator('email', {
                  initialValue: beforeRegistration.email || '',
                  rules: [
                    {
                      transform: transformTrim,
                      validator: (rule, value, cb) => {
                        if (!this.state.initialStart || (value && validator.isEmail(value))) {
                          cb();
                          this.handleChange('trueSet', { value, userRes });
                        } else {
                          cb(
                            intl.formatMessage({
                              id: notEmptyField(value, 'Некорректная электронная почта'),
                            }),
                          );
                        }
                      },
                    },
                  ],
                })(
                  <Input
                    type="text"
                    name="username"
                    disabled={userRes}
                    className={cx({
                      [s.inputFormMobil]: isMobile,
                      [s.inputForm]: !isMobile,
                    })}
                    onPressEnter={() => this.handleChange(userRes ? 'passwordSet' : 'formSet')}
                    placeholder={intl.formatMessage({
                      id: 'Электронная почта',
                    })}
                  />,
                )}
              </FormItem>
            </Row>
          ) : (
            ''
          )}
          <Row>
            <FormItem>
              {getFieldDecorator('name', {
                initialValue: beforeRegistration.name,
                rules: [
                  {
                    transform: transformTrim,
                    validator: (rule, value, cb) => {
                      if (!this.state.initialStart || (value && regexp.name.test(value))) {
                        cb();
                        this.handleChange('trueSet', { value, userRes });
                      } else {
                        cb(intl.formatMessage({ id: notEmptyField(value, 'Некорректная имя') }));
                      }
                    },
                  },
                ],
              })(
                <Input
                  type="text"
                  name="username"
                  disabled={userRes}
                  className={cx({
                    [s.inputFormMobil]: isMobile,
                    [s.inputForm]: !isMobile,
                  })}
                  onPressEnter={() => this.handleChange(userRes ? 'passwordSet' : 'formSet')}
                  placeholder={intl.formatMessage({
                    id: `Имя`,
                  })}
                />,
              )}
            </FormItem>
          </Row>
          {userRes
            ? [
                <Row key="0">
                  <Row>
                    <FormattedMessage id="Введите пароль, который вы получите на указанный телефон" />
                  </Row>
                  <Row>
                    <FormItem>
                      {getFieldDecorator('password', {
                        rules: [
                          {
                            transform: transformTrim,
                            validator: (rule, value, cb) => {
                              if (!this.state.initialpasswordStart) {
                                cb();
                                return;
                              }
                              if (value && regexp.password.test(value)) {
                                cb();
                              } else {
                                cb(
                                  intl.formatMessage({
                                    id: notEmptyField(value, 'Введите пароль'),
                                  }),
                                );
                              }
                            },
                          },
                        ],
                      })(
                        <Input
                          name="password"
                          type="password"
                          onPressEnter={() =>
                            this.handleChange(userRes ? 'passwordSet' : 'formSet')
                          }
                          className={cx({
                            [s.inputFormMobil]: isMobile,
                            [s.inputForm]: !isMobile,
                          })}
                          placeholder={intl.formatMessage({
                            id: 'Введите полученный пароль',
                          })}
                        />,
                      )}
                    </FormItem>
                  </Row>
                </Row>,
              ]
            : ''}
          <div className={cx(s.centerBlock)}>
            <div>
              <Link
                className={cx(s.urlGl, s.linkBlockGl)}
                onClick={() => this.handleChange('clear')}
              >
                <FormattedMessage id="Я уже зарегистрирован (а)" />
              </Link>
            </div>
            <div />
            {userRes ? (
              <div>
                <Link
                  className={cx(s.urlGl, s.linkBlockGl)}
                  onClick={() => this.handleChange('justOncepassword')}
                >
                  <FormattedMessage id="Направить пароль еще раз" />
                </Link>
              </div>
            ) : (
              ''
            )}
          </div>
          {this.renderCaptcha()}
          {loading ? (
            <Row>
              <Loader isLoading />
            </Row>
          ) : (
            <Row>
              <button
                disabled={!gtokenv2}
                className={s.buttonFormGl}
                onClick={() => this.handleChange(userRes ? 'passwordSet' : 'formSet')}
              >
                <p>
                  <FormattedMessage id="Зарегистрироваться" />
                </p>
              </button>
            </Row>
          )}
        </div>
      );
    }
    return (
      <div>
        <Row>
          <div className={s.sbsGL}>
            <img src={logoUrl} width={224} alt="avtobazar.ua" />
          </div>
        </Row>
        <Row>
          <div className={s.titleNellGl}>
            <FormattedMessage id="Вход" />
          </div>
        </Row>
        <Row>
          <FormItem>
            {getFieldDecorator('emailAndPhone', {
              initialValue: beforeRegistration.mailVerify || beforeRegistration.email || '',
              rules: [
                {
                  transform: transformTrim,
                  validator: (rule, value, cb) => {
                    if (
                      !this.state.initialStart ||
                      (value && (validator.isEmail(value) || regexp.phone.test(value)))
                    ) {
                      cb();
                    } else {
                      cb(
                        intl.formatMessage({
                          id: notEmptyField(value, 'Некорректный формат телефона или почты'),
                        }),
                      );
                    }
                  },
                },
              ],
            })(
              <Input
                type="text"
                name="username"
                disabled={checkCode}
                suffix={
                  checkCode ? (
                    <Icon
                      type="close"
                      onClick={() => this.handleChange('clear')}
                      style={{ cursor: 'pointer' }}
                    />
                  ) : (
                    <p />
                  )
                }
                className={cx({
                  [s.inputFormMobilLogin]: isMobile,
                  [s.inputFormLogin]: !isMobile,
                })}
                onPressEnter={() => this.handleChange(checkCode ? 'logoSet' : 'checkCode')}
                placeholder={intl.formatMessage({
                  id: isMobile
                    ? 'Введите телефон или почту'
                    : 'Введите мобильный телефон или почту',
                })}
              />,
            )}
          </FormItem>
        </Row>
        {checkCode ? (
          <Row>
            <FormItem>
              {getFieldDecorator('password', {
                rules: [
                  {
                    transform: transformTrim,
                    validator: (rule, value, cb) => {
                      if (!this.state.initialStart || (value && regexp.password.test(value))) {
                        cb();
                      } else {
                        cb(
                          intl.formatMessage({
                            id: notEmptyField(value, 'Некорректный пароль'),
                          }),
                        );
                      }
                    },
                  },
                ],
              })(
                <Input
                  name="password"
                  type="password"
                  onPressEnter={() => this.handleChange(checkCode ? 'logoSet' : 'checkCode')}
                  className={cx({
                    [s.inputFormMobil]: isMobile,
                    [s.inputForm]: !isMobile,
                  })}
                  placeholder={intl.formatMessage({
                    id: 'Введите пароль',
                  })}
                />,
              )}
            </FormItem>
          </Row>
        ) : (
          ''
        )}
        <div className={cx(s.centerBlock)}>
          <div>
            {checkCode ? (
              <Link className={s.urlGl} onClick={() => this.handleChange('checkCode', true)}>
                <FormattedMessage id="Зарегистрироваться" />
              </Link>
            ) : (
              ''
            )}
          </div>

          <div />
          <div>
            {checkCode ? (
              <Link
                className={s.urlGl}
                onClick={() => {
                  this.handleChange('logistics', 'wA4twgrZYU');
                  this.handleChange('recoverypassword');
                }}
              >
                <FormattedMessage id="Забыли пароль ?" />
              </Link>
            ) : (
              ''
            )}
          </div>
        </div>
        <Row>
          <button
            onClick={() => this.handleChange(checkCode ? 'logoSet' : 'checkCode')}
            className={s.buttonFormGl}
            // disabled={!regexp.password.test(String(getFieldValue('password')))}
          >
            <p>
              <FormattedMessage id="Продолжить" />
            </p>
          </button>
        </Row>
        {/* <Row>
          <FacebookLogin
            isMobile={false}
            appId={FB_APP_ID}
            callback={dat => this.handleChange('facebookLogoSet', dat)}
            render={({ onClick }) =>
              <button onClick={onClick} className={`${s.buttonFormGl} ${s.facebookButton}`}>
                <FormattedMessage id="Продолжить" /> <FormattedMessage id="с" /> Facebook
              </button>}
          />
        </Row> */}
        <Row>
          <p className={s.agreementGl}>
            <FormattedMessage id="Авторизовавшись на сайте, я соглашаюсь с" />{' '}
            <a href={URL.law()} target="_blank" rel="noopener noreferrer">
              <FormattedMessage id="политикой конфиденциальности" />
            </a>{' '}
            <FormattedMessage id="и даю согласие на обработку своих персональных данных, а также подтверждаю, что меня уведомили о внесении моих данных в базу персональных данных" />
          </p>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = ({ loading: { start }, user }) => ({
  loading: Boolean(start),
  user,
  enqueueNotification,
});

const mapDispatchToProps = dispatch => ({
  action: bindActionCreators(
    {
      logistics,
      userAuthorize,
      setDataLayer,
      userCheckCode,
      registration,
      userRecovery,
      loginWithFacebookToken,
      renderRecaptchaV2,
    },
    dispatch,
  ),
  dispatch,
  setBeforeRegistration,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Form.create()(withOrders(injectIntl(withStyles(s)(loginUsForm)))));



// WEBPACK FOOTER //
// ./src/shared/components/LoginUsForm/LoginUsForm.js